module.exports = __webpack_public_path__ + "static/img/12.8e44de5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/12.jpg
// module id = hFSN
// module chunks = 1